import * as React from "react";

export default () => {
  return <div>Bilder på objektet</div>;
};
